import { Col, Icon, Row, Select, message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";

import {
  ADD_AILMENT,
  DELETE_AILMENT,
  SET_SPECIALITIES,
} from "../../ActionTypes/ActionTypes";
import Ailment from "./Ailment";

const { Option } = Select;

class AilmentSupport extends Component {
  state = {
    loading: false,
    primarySpec: "",
    secondrySpec: "",
    ailments: [],
  };

  ail1input = React.createRef();

  ail2input = React.createRef();

  componentDidMount = () => {
    const { specialities } = this.props;

    if (specialities.length === 0) {
      this.getAllSpecialities();
    }
  };

  getAllSpecialities = () => {
    const { setSpeciality } = this.props;

    axios({
      method: "get",
      url: "/specialities.json",
      headers: { Authorization: sessionStorage.getItem("jwtToken") },
    }).then((response) => {
      setSpeciality(response.data);
    });
  };

  primarySpecialityChange = (value) => {
    // console.log(value);
    this.setState({
      primarySpec: Number(value),
    });
  };

  secondrySpecialityChange = (value) => {
    // console.log(value);
    this.setState({
      secondrySpec: Number(value),
    });
  };

  // onPrimaryAilChange = (value) => {
  //     this.setState({ fetching: true });
  //     fetch(value, (result) => {
  //         this.setState({
  //             primaryAil: value,
  //             ailments: result,
  //             fetching: false,
  //         });
  //     });
  // }

  // onSecondryAilChange = (value) => {
  //     this.setState({ fetching: true });
  //     fetch(value, (result) => {
  //         this.setState({
  //             secondryAil: value,
  //             ailments: result,
  //             fetching: false,
  //         });
  //     });
  // }

  onPrimaryAilSelect = (value) => {
    const { order_ailments } = this.props;
    const { primarySpec } = this.state;

    const ail = order_ailments.filter(
      (ailm) =>
        Number(ailm.order_ailment_id) === Number(value) &&
        Number(ailm.order_speciality_id) === Number(primarySpec)
    );
    if (ail.length === 0) {
      this.ailmentSelect(value, true, primarySpec);
    } else {
      message.warning("Ailment is already added!");
    }
  };

  onSecondryAilSelect = (value) => {
    const { order_ailments } = this.props;
    const { secondrySpec } = this.state;

    const ail = order_ailments.filter(
      (ailm) =>
        Number(ailm.order_ailment_id) === Number(value) &&
        Number(ailm.order_speciality_id) === Number(secondrySpec)
    );
    if (ail.length === 0) {
      this.ailmentSelect(value, false, secondrySpec);
    } else {
      message.warning("Ailment is already added!");
    }
  };

  ailmentSelect = (value, primary, spec) => {
    const { order_id, setAilment } = this.props;
    // console.log(
    //     order_id, value, spec, primary,
    // );

    axios({
      method: "post",
      url: "/order_ailments.json",
      headers: { Authorization: sessionStorage.getItem("jwtToken") },
      data: {
        order_ailment: {
          order_id,
          ailment_id: value,
          speciality_id: spec,
          primary_ailment: primary,
        },
      },
    }).then((response) => {
      setAilment(response.data);
    });
  };

  onPrimaryAilSubmit = () => {
    const { primarySpec } = this.state;
    this.ailmentCreate(this.ail1input.current.value, primarySpec, true);
  };

  onSecondryAilSubmit = () => {
    const { secondrySpec } = this.state;
    this.ailmentCreate(this.ail2input.current.value, secondrySpec, false);
  };

  ailmentCreate = (name, spec, primary) => {
    const { order_id, setAilment } = this.props;

    axios({
      method: "post",
      url: "/order_ailments/define_ailments.json",
      headers: { Authorization: sessionStorage.getItem("jwtToken") },
      data: {
        order_id,
        ailment_name: name,
        speciality_id: spec,
        primary_ailment: primary,
      },
    }).then((response) => {
      setAilment(response.data);
      this.ail1input = "";
      this.ail2input = "";
    });
  };

  onDeleteAil = (id) => {
    const { deleteAIlment } = this.props;
    axios({
      method: "delete",
      url: `/order_ailments/${id}.json`,
      headers: { Authorization: sessionStorage.getItem("jwtToken") },
    }).then(() => {
      deleteAIlment(id);
      window.location.reload();
    });
  };

  render() {
    const { loading, primarySpec, secondrySpec } = this.state;
    const { order_ailments, specialities } = this.props;

    let primaryAils;
    let secondryAils;

    if (order_ailments == null) {
      primaryAils = [];
      secondryAils = [];
    } else {
      primaryAils = order_ailments.filter(
        (ail) => ail.primary_ailment === true
      );
      secondryAils = order_ailments.filter(
        (ail) => ail.primary_ailment !== true
      );
    }

    const specialitiesOption = specialities.map((sps) => (
      <Option key={sps.id} value={sps.id}>
        {sps.name}
      </Option>
    ));

    const primaryAilOption = specialities.filter(
      (sps) => sps.id === primarySpec
    )[0];
    const secondryAilOption = specialities.filter(
      (sps) => sps.id === secondrySpec
    )[0];

    // console.log(primaryAilOption);

    let primaryAilOptions;
    let secondryAilOptions;

    if (primaryAilOption !== undefined) {
      primaryAilOptions = primaryAilOption.ailments.map((ail) => (
        <Option key={ail.id} value={ail.id}>
          {ail.name}
        </Option>
      ));
    } else {
      primaryAilOptions = <Option key="" value="" />;
    }

    if (secondryAilOption !== undefined) {
      secondryAilOptions = secondryAilOption.ailments.map((ail) => (
        <Option key={ail.id} value={ail.id}>
          {ail.name}
        </Option>
      ));
    } else {
      secondryAilOptions = <Option key="" value="" />;
    }

    return (
      <div>
        <h4>Ailments</h4>
        <hr width="100" />

        <Icon
          type="reload"
          onClick={this.getAllSpecialities}
          style={{ color: "blue", fontSize: 20, cursor: "pointer" }}
        />

        <Row justify="space-around">
          <Col span={12}>
            <Ailment
              loading={loading}
              specialitiesOption={specialitiesOption}
              ailmentOptions={primaryAilOptions}
              inputAil={this.ail1input}
              spec={primarySpec}
              handleSpecChange={this.primarySpecialityChange}
              header="Primary Ailment"
              ailments={primaryAils}
              deleteAil={this.onDeleteAil}
              onAilSelect={this.onPrimaryAilSelect}
              onAilSubmit={this.onPrimaryAilSubmit}
            />
          </Col>

          <Col span={12}>
            <Ailment
              loading={loading}
              specialitiesOption={specialitiesOption}
              ailmentOptions={secondryAilOptions}
              inputAil={this.ail2input}
              spec={secondrySpec}
              handleSpecChange={this.secondrySpecialityChange}
              header="Secondry Ailment"
              ailments={secondryAils}
              deleteAil={this.onDeleteAil}
              onAilSelect={this.onSecondryAilSelect}
              onAilSubmit={this.onSecondryAilSubmit}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  specialities: state.AppState.specialities,
  order_id: state.AppState.order_id,
  order_ailments: state.AppState.ailments,
  // e_prescription_id: state.AppState.ep_id,
});

const mapDispatchToProps = (dispatch) => ({
  setSpeciality: (sps) =>
    dispatch({ type: SET_SPECIALITIES, payload: { sps } }),
  setAilment: (ail) => dispatch({ type: ADD_AILMENT, payload: { ail } }),
  deleteAIlment: (id) => dispatch({ type: DELETE_AILMENT, payload: { id } }),
});

export default connect(mapStateToProps, mapDispatchToProps)(AilmentSupport);



// WEBPACK FOOTER //
// ./src/component/FetchOrderList/AilmentSupport.js